<template>
  <div class="admin-theme">
    <v-icon @click="visible = !visible" style="cursor: pointer;" icon="SettingOutlined" size="14px"/>
  </div>

  <a-drawer
      v-model:visible="visible"
      :maskClosable="false"
      title="自定义主题"
      :width="480"
      class="admin-theme-modal"
      destroy-on-close
  >


    <template #footer>
      <div class="footer">
        <a-space :size="16">
          <a-button plain @click="copyText">导出配置</a-button>
          <a-button plain @click="clear">清除缓存</a-button>
          <a-button type="primary" @click="visible = false">确认修改</a-button>
        </a-space>
      </div>
    </template>

    <h2>主题颜色</h2>

    <ul class="colors">
      <template v-for="i of themes" :key="i.color">
        <li @click="setTheme(i)" class="color">
          <div :class="{active :usedTheme.primaryColor === i.primaryColor && usedTheme.name === i.name}" class="show">
            <div class="i" :style="{backgroundColor:i.primaryColor}">
            </div>
          </div>
          <span class="text">{{ i.name }}</span>
        </li>
      </template>

      <v-color-picker v-model:color="usedTheme.primaryColor">
        <li class="color">
          <div @click="setTheme(makeTheme)"
               :class="{active :usedTheme.primaryColor === makeTheme.primaryColor && usedTheme.name === makeTheme.name}"
               class="show">
            <div class="i" :style="{backgroundColor:makeTheme.primaryColor}">
            </div>
          </div>
          <span class="text">{{ makeTheme.name }}</span>
        </li>
      </v-color-picker>


    </ul>

    <h2>主题定制</h2>


    <!-- 订 -->
    <ul class="layout">
      <li>
        <div class="segment">
          导航栏背景颜色
        </div>
        <v-color-picker v-model:color="usedTheme.adminHeaderBgcolor" :show="true"/>
      </li>
      <li>
        <div class="segment">
          导航栏字体颜色
        </div>
        <v-color-picker v-model:color="usedTheme.adminHeaderColor" :show="true"/>
      </li>
      <li>
        <div class="segment">
          导航栏下边框颜色
        </div>
        <v-color-picker v-model:color="usedTheme.adminHeaderBorder" :show="true"/>
      </li>
      <li>
        <div class="segment">
          侧边栏背景颜色
        </div>
        <v-color-picker v-model:color="usedTheme.adminSiderBg" :show="true"/>
      </li>
      <li>
        <div class="segment">
          侧边栏字体颜色
        </div>
        <v-color-picker v-model:color="usedTheme.adminMenuColor" :show="true"/>
      </li>
      <li>
        <div class="segment">
          侧边栏菜单激活时背景颜色
        </div>
        <v-color-picker v-model:color="usedTheme.sidebarHoverBgColor" :show="true"/>
      </li>
      <li>
        <div class="segment">
          侧边栏菜单激活时字体颜色
        </div>
        <v-color-picker v-model:color="usedTheme.sidebarHoverColor" :show="true"/>
      </li>
    </ul>


  </a-drawer>

  <!-- 复制 -->
  <span :data-clipboard-text="text" ref="copy_dom" hidden></span>
</template>

<script setup>
/* eslint-disable */
import {nextTick, ref, watch} from 'vue';
import {useLocalStorage} from "@vueuse/core";
import {themes} from '@/config/theme'
import {cloneDeep, debounce} from "lodash";
import copy from "@/common/copy";
import load from "@/common/load";

/* 主题定制面板是否可见 */
const visible = ref(false);

/* 主题 */
/** @type theme */
const usedTheme = useLocalStorage('theme', themes[0]);

/* 同步自定义主题的变化 */
watch(() => usedTheme.value, () => {
  if (usedTheme.value.name === '自定义') {
    makeTheme.value = usedTheme.value;
  }
})


/* 自定义 */
/** @type theme */
const makeTheme = useLocalStorage('makeTheme', Object.assign(cloneDeep(themes[0]), {
  name: "自定义"
}));


/**
 * 设置主题
 * @param theme
 */
const setTheme = (theme) => {
  usedTheme.value = theme;
}


/**
 * 复制配置
 */
const {
  text,
  copy_dom
} = copy();


/**
 * 复制文本
 */
const copyText = () => {
  text.value = JSON.stringify(usedTheme.value);
  nextTick(() => {
    copy_dom.value.click();
  })
}


/**
 * 清除
 */
const clear = () => {
  localStorage.removeItem('theme');
  load.success("清除成功！");
}

</script>


<style lang="scss">
.admin-theme-modal {
  .ant-drawer-body {
    @include scroll-bar();
    padding: 18px;

    h2 {
      font-size: 16px;
      font-weight: bold;
    }

    .colors {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      list-style: none;
      padding: 0;
      gap: 10px;

      .color {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: calc(20% - 8px);
        margin-top: 6px;
        cursor: pointer;

        .show {
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 8px;
          padding: 8px 21px;
          border: 1px solid $border;
          width: 100%;

          .i {
            width: 36px;
            height: 36px;
            flex-grow: 0;
            flex-shrink: 0;
            border-radius: 12px;
          }
        }


        .active {
          position: relative;

          &:before {
            position: absolute;
            display: block;
            content: " ";
            border-radius: 8px;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            border: 3px solid var(--ant-primary-color);
          }
        }

        .text {
          margin-top: 5px;
        }


      }


    }

  }
}
</style>

<style scoped lang="scss">
.admin-theme {
  @include flex-center;
  justify-content: center;
  width: 30px;
  height: 30px;
  margin-right: 12px;
  padding: 5px;
  border-radius: 50%;
  color: $text-color-3;
  border: 1px solid $border;
}

.footer {
  display: flex;
  justify-content: flex-end;
  width: 100%;
}

.layout {

  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  list-style: none;
  padding: 15px 20px 0 10px;

  li {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-bottom: 15px;
  }
}

</style>